__turbopack_context__.v({
  "chart": "Mq7BSa_chart",
  "label": "Mq7BSa_label",
  "output": "Mq7BSa_output",
});
